import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.audienceMetricData`;
export const INIT = `${SCOPE}/INIT`;
export const FETCH_DATA = `${SCOPE}/FETCH_DATA`;
export const SET_FETCHING = `${SCOPE}/SET_FETCHING`;
export const SET_RESPONSE = `${SCOPE}/SET_RESPONSE`;
export const SET_ERROR = `${SCOPE}/SET_ERROR`;
export const SAVE_CHART_DATA = `${SCOPE}/SAVE_CHART_DATA`;
